import { calcWidth, isWeb } from '../dimensions';

export const APP_DRAWER_WIDTH = calcWidth(285);
export const WEB_DRAWER_WIDTH = 290;
export const DRAWER_FORM_WIDTH = isWeb ? APP_DRAWER_WIDTH + calcWidth(50) : APP_DRAWER_WIDTH - calcWidth(48);
